import React, { Component, Fragment } from 'react';

class MealTypes extends Component {
  render() {
   
    const dataArray = this.props.dataArray || {};
    const diet = this.props.diet;
    const mealType = this.props.mealType || [];

    const typeList = dataArray.typeList || {};
    const dietMobileList =
      dataArray.dietMobileList || [];

    const mealTypeList =
      dietMobileList.filter(function(value) {
        return (
          value.id == diet &&
          value.mealtypes
        );
      });

    if (
      mealTypeList.length === 0 ||
      !mealTypeList[0].mealtypes
    ) {
      return (
        <section
          className="step-form-input"
          id="meals"
        />
      );
    }

    return (
      <section
        className="step-form-input"
        id="meals"
      >
        <div className="goal-heading">
          <div className="goal-number">
            02
          </div>
          <h2>Choose your meals?</h2>
          <span>02</span>
        </div>

        <div className="meal-grid">
          {mealTypeList[0].mealtypes.map(
            function(item, index) {
              let type = typeList[item] || {};

              return (
                <Fragment key={item}>
                  <label
                    className="meal-type-card"
                    htmlFor={
                      'labelmealtype-' +
                      index
                    }
                  >
                    <input
                      type="checkbox"
                      value={+item}
                      name="mealtype"
                      id={
                        'labelmealtype-' +
                        index
                      }
                      checked={
                        mealType.indexOf(
                          +item
                        ) !== -1
                      }
                      onChange={function() {
                        this.props.onMealTypeChange(
                          +item
                        );
                      }.bind(this)}
                    />

                    <span className="avenir-heavy font-16">
                      {type.title}
                    </span>

                    <div className="checkmark1">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M6 10.8L3.2 8L2 9.2L6 13.2L14 5.2L12.8 4L6 10.8Z"
                          fill="white"
                        />
                      </svg>
                    </div>
                  </label>
                </Fragment>
              );
            }.bind(this)
          )}
        </div>
      </section>
    );
  }
}

export default MealTypes;
